// extracted by mini-css-extract-plugin
module.exports = {"home":"LoanReports_home__2gPGf","actionButton":"LoanReports_actionButton__1N1mG","leftMargin":"LoanReports_leftMargin__2tv4e"};